import Fetch, { fetchConfig } from '@/hooks/fetch';
import actions from '../constants';

export default {
  useFetchDictionaryMarkdown: ({ category, code, datasetCode }, readStatus) => Fetch.useFetchDispatch(
    actions.FETCH_DICTIONARY_MARKDOWN,
    readStatus,
    { category, code, datasetCode },
    fetchConfig([category, code, readStatus]),
  ),
};
